import React, { Component } from 'react';
import { Form, Input, Button, Modal } from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
// import { getSnapshot, applySnapshot, hasParent } from 'mobx-state-tree';

class StandardOperationForm extends Component {

  // initialSnapshot = null

  // constructor(props) {
  //   super(props)
  //   if (!props.model) return
  //   this.initialSnapshot = getSnapshot(props.model)
  // }

  render() { 
    const { model } = this.props
    if (!model) return null
    return (
      <Modal open={this.props.isOpen} size='tiny'>
        <Modal.Header content='Standard Operation' />
        <Modal.Content scrolling>
          <Form as='div'>
            <Form.Input name='description' value={model.description} label='Description' onChange={this.handleChangeDescription} autoFocus />
            <Form.Group widths='equal'>
              <Form.Field>
                <label>Setup time</label>
                <Input fluid type='number' label='minutes' labelPosition='right' value={model.minutesPerSetup} onChange={this.handleChangeSetupTime} />
              </Form.Field>
              <Form.Field>
                <label>Operation time</label>
                <Input fluid type='number' label='seconds' labelPosition='right' value={model.secondsPerOperation} onChange={this.handleChangeOperationTime} />
              </Form.Field>
            </Form.Group>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button type='button' positive disabled={!model.isValid} onClick={this.handleSave} content='Save' />
          <Button type='button' color='orange' onClick={this.handleCancel} content='Cancel' />
        </Modal.Actions>
      </Modal>
    )
  }

  handleSave = () => {
    // const { model, store, onClose } = this.props
    // if (!hasParent(model)) {
    //   store.setCollectionItemFromSnapshot('standardOperations', getSnapshot(model))
    // }
    // model.save()
    this.props.onSave()
    this.props.onClose()
  }

  handleCancel = () => {
    // applySnapshot(this.props.model, this.initialSnapshot)
    this.props.onClose()
  }

  handleChangeDescription = event => this.props.model.setDescription(event.target.value)

  handleChangeSetupTime = event => {
    const parsedValue = parseInt(event.target.value, 10)
    if (!isNaN(parsedValue)) this.props.model.setSetupTime(parsedValue)
  }

  handleChangeOperationTime = event => {
    const parsedValue = parseInt(event.target.value, 10)
    if (!isNaN(parsedValue)) this.props.model.setOperationTime(parsedValue)
  }

}

export default inject('store')(observer(StandardOperationForm));


// WEBPACK FOOTER //
// ./src/components/standard-operations/StandardOperationForm.js